// Module
var code = "<div class=\"left-elements\" ng-transclude></div>\n<div class=\"right-elements\">\n    <app-common-elements on-export=\"onExport\"></app-common-elements>\n</div>\n";
// Exports
module.exports = code;